import { Box, Flex, Text } from "@chakra-ui/react";

// Shared "vs target" bar used on the supplier tracking / target-delta cards.
// The target sits at the centre marker; the fill runs from the centre
// outwards proportional to the delta — red to the RIGHT when over target,
// green to the LEFT when under. A full half-bar = 100% over/under (values
// beyond that are clamped so the bar stays inside the card).
//
// Props:
//  - delta: signed % over(+)/under(-) target. null → renders an empty track.
const TargetBar = ({ delta }) => {
  const hasDelta = typeof delta === "number";
  const overTarget = hasDelta && delta > 0;
  const barColor = !hasDelta ? "gray.300" : overTarget ? "red.500" : "green.500";

  const magnitude = hasDelta ? Math.min(100, Math.abs(delta)) : 0;
  const halfFillPct = (magnitude / 100) * 50; // % of the full-width track

  return (
    <Box position="relative">
      <Box h="10px" bg="gray.100" borderRadius="full" position="relative" overflow="hidden">
        {hasDelta && magnitude > 0 && (
          <Box
            position="absolute"
            top={0}
            h="100%"
            w={`${halfFillPct}%`}
            bg={barColor}
            left={overTarget ? "50%" : undefined}
            right={overTarget ? undefined : "50%"}
            transition="width 0.3s ease"
          />
        )}
      </Box>
      {/* target marker at centre */}
      <Box position="absolute" top="-3px" left="50%" transform="translateX(-50%)" w="2px" h="16px" bg="gray.600" />
      <Flex justify="space-between" mt={2}>
        <Text fontSize="10px" color="gray.400">
          ahead
        </Text>
        <Text fontSize="10px" color="gray.500" fontWeight="600">
          target
        </Text>
        <Text fontSize="10px" color="gray.400">
          behind
        </Text>
      </Flex>
    </Box>
  );
};

export default TargetBar;
